<template>
  <div>
    <v-card v-if="!isLoading">
      <v-card-title class="body-1 pa-4 white--text flex-column align-start" style="line-height: 1" :class="{ primary: !disabled, 'grey lighten-2': disabled, 'py-3': !!subtitle }">
        <span class="text-uppercase">{{ title }}</span>
        <span v-if="subtitle" class="mt-1 font-weight-light" style="font-size: 11px">{{ subtitle }}</span>
      </v-card-title>
      <div>
        <slot />
      </div>
    </v-card>
    <div v-else class="elevation-2">
      <v-skeleton-loader class="pa-2" type="heading" />
      <v-skeleton-loader type="divider, list-item-three-line, list-item-three-line, card-heading" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    subtitle: { type: String, default: '' },
    title: { type: String, required: true }
  }
}
</script>
